// extracted by mini-css-extract-plugin
export default {"editorContainer":"FieldExtension_editorContainer__LegwY","button":"FieldExtension_button__uQGDa"};